import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BaseDataBindingDirective } from "./base-data-binding.directive";
import { FormSubmissionsBindingDirective } from "./form-submissions-binding.directive";
import { FormsBindingDirective } from "./forms-binding.directive";
import { SplitContainerDirective } from "./split-container.directive";
import { SplitContentDirective } from "./split-content.directive";
import { SplitSecondaryContentDirective } from "./split-secondary-content.directive";
import { ActiveSubmissionsBindingDirective } from "./active-submissions-binding.directive";
import { ActiveTasksBindingDirective } from "./active-tasks-binding.directive";
import { StopPropagationDirective } from "./stop-propagation.directive";
import { LookupsBindingDirective } from "./lookups-binding.directive";
import { MyTasksBindingDirective } from "./my-tasks-binding.directive";

@NgModule({
    declarations: [
        BaseDataBindingDirective,
        FormsBindingDirective,
        FormSubmissionsBindingDirective,
        SplitContainerDirective,
        SplitContentDirective,
        SplitSecondaryContentDirective,
        ActiveSubmissionsBindingDirective,
        ActiveTasksBindingDirective,
        StopPropagationDirective,
        LookupsBindingDirective,
        MyTasksBindingDirective,
    ],
    imports: [CommonModule],
    exports: [
        BaseDataBindingDirective,
        FormsBindingDirective,
        FormSubmissionsBindingDirective,
        ActiveSubmissionsBindingDirective,
        ActiveTasksBindingDirective,
        SplitContainerDirective,
        SplitContentDirective,
        SplitSecondaryContentDirective,
        StopPropagationDirective,
        LookupsBindingDirective,
        MyTasksBindingDirective,
    ],
})
export class DirectivesModule {}
